import SesionHero from "@/components/site/sesion/SesionHero";
import SesionReasons from "@/components/site/sesion/SesionReasons";
import SesionPromise from "@/components/site/sesion/SesionPromise";
import SesionCalBooking from "@/components/site/sesion/SesionCalBooking";
import SesionForm from "@/components/site/sesion/SesionForm";
import SesionClosing from "@/components/site/sesion/SesionClosing";
import useSeo from "@/lib/useSeo";

const SesionGratuita = () => {
  useSeo({
    title: {
      es: "Sesión Gratuita 15 min · Reserva Online | Método TAO by Marta",
      ca: "Sessió Gratuïta 15 min · Reserva Online | Mètode TAO by Marta",
    },
    description: {
      es: "Reserva ahora una primera videollamada gratuita de 15 minutos sin compromiso. Para personas con cáncer, fibromialgia, fatiga crónica o dolor persistente que quieren conocer cómo el Método TAO puede acompañarlas.",
      ca: "Reserva ara una primera videotrucada gratuïta de 15 minuts sense compromís. Per a persones amb càncer, fibromiàlgia, fatiga crònica o dolor persistent que volen conèixer com el Mètode TAO les pot acompanyar.",
    },
    path: "/sesion-gratuita",
  });

  return (
    <div className="bg-ivory">
      <SesionHero />
      <SesionReasons />
      <SesionPromise />
      <SesionCalBooking />
      <SesionForm />
      <SesionClosing />
    </div>
  );
};

export default SesionGratuita;
